import React from 'react'
import MaterialInput from './MaterialInput'
import { Box, Divider, Grid } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'react-i18next'
import ElementContainer from '../../ElementContainer'
import SwipeableComponent from './SwipeableComponent'

import { singleMaterialStyles } from '../../../../styles/classes/MobilePreviewClasses'
import { itemPriceOptionsObj } from '../../../../utils/formBuilder'

const SingleMaterial = ({
  item,
  index,
  onChange,
  onRemove,
  disabled,
  helpfulHint,
  isMandatory,
  question,
  updateCallback
}) => {
  const enableAmounts =
    question?.item_price ===
    itemPriceOptionsObj.ENABLE_ITEM_PRICE_TAX_TOTAL_PRICE
  const { t } = useTranslation()
  const { classes } = singleMaterialStyles()
  const RightButton = () => {
    return (
      <div className={classes.deleteButton} onClick={() => onRemove(index)}>
        <FontAwesomeIcon className={classes.icon} icon={faTrash} />
      </div>
    )
  }

  return (
    <SwipeableComponent rightButton={<RightButton />}>
      <ElementContainer
        title={`${t('mobile_preview.material.material')} ${index + 1}`}
        helpfulHint={helpfulHint}
        isMandatory={isMandatory}
      >
        <MaterialInput
          onBlur={updateCallback}
          required={true}
          placeholder={t('mobile_preview.material.enter_name')}
          onChange={e => onChange(index, 'name', e.target.value)}
          value={item.name}
          disabled={disabled}
        />
        <MaterialInput
          onBlur={updateCallback}
          customClasses={classes.description}
          multiline={true}
          disabled={disabled}
          placeholder={t('mobile_preview.material.enter_description')}
          label={t('mobile_preview.material.item_description')}
          onChange={e => onChange(index, 'description', e.target.value)}
          value={item.description}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', flex: 3 }}>
            <MaterialInput
              onBlur={updateCallback}
              disabled={disabled}
              placeholder={`${t('mobile_preview.material.item')} #`}
              label={`${t('mobile_preview.material.item')} #`}
              onChange={e => onChange(index, 'number', e.target.value)}
              value={item.number}
            />
          </Box>
          <Box
            sx={{ width: '20px', justifyContent: 'center', display: 'flex' }}
          >
            <Divider orientation="vertical" className={classes.divider} />
          </Box>
          <Box sx={{ display: 'flex', flex: 1.33 }}>
            <MaterialInput
              onBlur={updateCallback}
              disabled={disabled}
              required={true}
              placeholder={t('mobile_preview.material.quantity')}
              label={t('mobile_preview.material.qty')}
              onChange={e => onChange(index, 'quantity', e.target.value)}
              value={item.quantity}
            />
          </Box>
        </Box>

        {enableAmounts && (
          <Grid container sx={{ marginTop: '10px' }}>
            <Grid item xs>
              <MaterialInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={`${t('mobile_preview.material.per_item_price')}`}
                label={`${t('mobile_preview.material.price')}`}
                onChange={e => onChange(index, 'price', e.target.value)}
                value={item.price}
              />
            </Grid>
            <Grid item xs={1} className={classes.dividerContainer}>
              <Divider orientation="vertical" className={classes.divider} />
            </Grid>
            <Grid item xs>
              <MaterialInput
                onBlur={updateCallback}
                disabled={disabled}
                placeholder={`${t('mobile_preview.material.tax')} (%)`}
                label={`${t('mobile_preview.material.tax')} %`}
                onChange={e => onChange(index, 'tax', e.target.value)}
                value={item.tax}
              />
            </Grid>
            <Grid item xs={1} className={classes.dividerContainer}>
              <Divider orientation="vertical" className={classes.divider} />
            </Grid>
            <Grid item xs>
              <MaterialInput
                onBlur={updateCallback}
                disabled={true} // always disabled
                placeholder={'0.00'}
                label={`${t('mobile_preview.material.total_price')}`}
                onChange={e => onChange(index, 'total_price', e.target.value)}
                value={item.total_price}
              />
            </Grid>
          </Grid>
        )}
      </ElementContainer>
    </SwipeableComponent>
  )
}

export default SingleMaterial
